var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuadChairs(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.116 18l-1.284-1.86-1.08 1.86h-2.22l2.208-3.42-2.268-3.276h2.304l1.284 1.848 1.08-1.848h2.22l-2.244 3.372L34.42 18h-2.304zm2.939-1.56v-1.656l3.792-5.424h2.292v5.304h.984v1.776h-.984V18h-2.052v-1.56h-4.032zm4.176-4.824l-2.016 3.048h2.016v-3.048z",
    fill: "#006FAC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quadChairs_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1 14.5c1-.9 2.6-.8 3.5.2.9 1 .8 2.5-.2 3.4-1 .9-2.6.8-3.5-.2-.9-1-.8-2.5.2-3.4zm-19-2.2c-.5.1-.7.6-.6 1.1.1.5.6.7 1.1.6l13.9-3.7.1.1c.4.3.8.6 1.3.7v22.2c0 .4.3.7.7.7h8c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-7.3V11.1c.4-.1.7-.3 1-.6.5-.4.8-1 .9-1.6L39 4.2c.5-.1.7-.6.6-1.1-.1-.5-.6-.7-1.1-.6L21 7.2c-.1-.2-.2-.4-.4-.5-1-1.1-2.7-1.2-3.9-.2-.6.6-.9 1.3-.9 2.1L2.1 12.3zm43.8 25.2l-27.3 7.7c-.4.1-.8-.1-.9-.5v-.1c-.1-.4.1-.7.5-.9l26.9-7.6.8-.8c.3-.3.8-.3 1.1 0 .3.3.3.8 0 1l-.7.7c0 .3-.2.5-.4.5zM21 19.9c1-.9 2.5-.8 3.4.2.5.6.5 1.1.6 2.1 0 .7 0 6.2.1 6.2.1.1 4.2.1 4.7.1.9 0 2.4 0 2.5 1.6.1 1.3 0 7.8.1 8.2 0 1.7-3 2.4-3-.2v-6s-4.6.1-6.9 0c-2.3-.1-2.1-2-2.1-2V21.9c-.2-.9 0-1.4.6-2z",
    fill: "#006DA9",
    stroke: "#006DA9",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quadChairs_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 2)",
    d: "M0 0h46.7v43.7H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuadChairs);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "dbf2632bf21e94e3c678f6246642edfb.svg";
export { MemoForwardRef as ReactComponent };